import { render } from "./MainService.vue?vue&type=template&id=ae73515c&scoped=true"
import script from "./MainService.vue?vue&type=script&lang=js"
export * from "./MainService.vue?vue&type=script&lang=js"

import "./MainService.vue?vue&type=style&index=0&id=ae73515c&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae73515c"]])

export default __exports__